<template lang="pug">
  .section
    .container
      .columns
        .column.is-6.is-offset-3
          .box
            h3.title.is-3(v-t="'account_setup.title'")
            form(v-on:submit.prevent="submit")
              b-field(:label="$t('account_setup.password_label')" :type="errors.has('password') ? 'is-danger': ''" :message="errors.has('password') ? errors.first('password') : ''")
                b-input(
                  type="password" 
                  ref="passwordInput" 
                  v-validate="'required|min:8|max:32|password'" 
                  :placeholder="$t('account_setup.password_placeholder')" 
                  icon="lock" 
                  v-model="password" 
                  name="password"
                  password-reveal)
              b-field(:label="$t('account_setup.password_repeat_label')" :type="errors.has('passwordConfirm') ? 'is-danger': ''" :message="errors.has('passwordConfirm') ? errors.first('passwordConfirm') : ''")
                b-input(
                  type="password" 
                  v-validate="{ is: password }" 
                  :placeholder="$t('account_setup.password_repeat_placeholder')" 
                  icon="lock" 
                  v-model="passwordConfirm" 
                  name="passwordConfirm"
                  password-reveal
                  data-vv-as="password confirmation")
              button.button.is-primary.is-fullwidth(type="submit", :class="submitting ? 'is-loading': ''") Sign in
</template>

<script>
import AuthApi from '@/api/auth'

export default {
  name: 'AccountSetup',
  data() {
    return {
      password: '',
      passwordConfirm: '',
      submitting: false
    }
  },
  mounted() {
    this.$refs.passwordInput.focus()
  },
  methods: {
    async submit() {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      try {
        await AuthApi.setPassword(this.$route.params.invitationkey, this.password)

        this.$buefy.toast.open({
          message: this.$t('account_setup.password_set_success'),
          type: 'is-success',
          duration: 5000,
          queue: false
        })
        this.submitting = false
        this.$router.push('/calendar')
      } catch (error) {
        this.submitting = false
        this.$handleAPIError(error)
      }
    }
  }
}
</script>
